<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
  >
    <template #activator="{ on }">
      <v-btn
        v-on="on"
        color="primary"
        icon
        class="mb-2"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
        <v-card-title>Add Cost</v-card-title>
        <v-card-text>
            <v-form ref="form">
                <v-select v-model="model.type" label="Type" :items="types" :rules="[rules.required]" />
                <v-text-field v-model="model.amount" label="Amount" type="number" :rules="[rules.required]" />
                <v-textarea v-model="model.note" label="Note" />
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text @click="dialog=false">Cancel</v-btn>
            <v-spacer />
            <v-btn color="primary" @click="save">Add</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    props:{
        poId:{
            type:Number,
            required:true
        }
    },
    data: () => ({
        model:{
            type: '',
            amount: 0,
            note: '',
        },
        dialog:false,
        types: [
            {id:'tax', text:'Tax'},
            {id:'shipping', text:'Shipping'},
            {id:'other', text:'Other'}
        ]
    }),
    computed:{
        rules: function() {
            return {
                required: value => !!value || "This field is mandatory.",
            };
        },
    },
    methods:{
        ...mapActions("purchaseOrders", ["addPayment"]),
        save(){
            if(this.$refs.form.validate()){
                this.addPayment({
                    poId:this.poId,
                    model:this.model
                })
                .then(({poPayment}) => {
                    this.dialog = false
                    this.$emit("add", poPayment)
                    this.model={
                        type: '',
                        amount: 0,
                        note: '',
                    }
                })
            }
        }
    }
}
</script>

<style>

</style>